<h2 [attr.data-omni-qa]="omniQaTag">
  <ng-content></ng-content>
</h2>
